import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/AuthStore';

import AuthLogin from '../views/auth/AuthLogin.vue';
import AuthRegister from '../views/auth/AuthRegister.vue';
import AuthRecovery from '../views/auth/AuthRecovery.vue';
import AuthRecoveryChangePassword from '../views/auth/AuthRecoveryChangePassword.vue';
import AuthInvitation from '../views/auth/AuthInvitation.vue';
import HomePage from '../views/HomePage.vue';
import ArticlesPage from '../views/articles/ArticlesPage.vue';
import ArticleStepPage from '../views/articles/ArticleStepPage.vue';
import ArticlesFormPage from '../views/articles/ArticlesFormPage.vue';
import ArticlesGenerateFormPage from '../views/articles/ArticlesGenerateFormPage.vue';
import ArticlesSharePage from '../views/articles/ArticlesSharePage.vue';
import SocialPages from '../views/social-pages/SocialPages.vue';
import SocialPagesFormPage from '../views/social-pages/SocialPagesFormPage.vue';
import SupportsPage from '../views/supports/SupportsPage.vue';
import SupportsFormPage from '../views/supports/SupportsFormPage.vue';
import SupportsViewPage from '../views/supports/SupportsViewPage.vue';
import PreAutorizationsPage from '../views/pre-authorizations/PreAutorizationsPage.vue';
import PreAutorizationsFormPage from '../views/pre-authorizations/PreAutorizationsFormPage.vue';
import PreAutorizationsViewPage from '../views/pre-authorizations/PreAutorizationsViewPage.vue';
import MessagesPage from '../views/messages/MessagesPage.vue';
import MessagesViewPage from '../views/messages/MessagesViewPage.vue';
import FaqsPage from '../views/faqs/FaqsPage.vue';
import FaqsViewPage from '../views/faqs/FaqsViewPage.vue';
import PaymentsPage from '../views/payments/PaymentsPage.vue';
import PaymentsViewPage from '../views/payments/PaymentsViewPage.vue';
import ReportsArticlePage from '@/views/reports/articles/ReportsArticlePage.vue';
import ReportsArticlesPage from '@/views/reports/articles/ReportsArticlesPage.vue';
import ReportPage from '@/views/reports/pages/ReportPage.vue';
import ReportPages from '@/views/reports/pages/ReportPages.vue';
import AccountPage from '@/views/account/AccountPage.vue';
import ArticlesLinksPage from '@/views/articles/ArticlesLinksPage.vue';
import ArticlesTopLinksPage from '@/views/articles/ArticlesTopLinksPage.vue';
import SuggestionsPage from '@/views/suggestions/SuggestionsPage.vue';
import SuggestionsFormPage from '@/views/suggestions/SuggestionsFormPage.vue';
import { useMenuStore } from '@/stores/MenuStore';
import ArticlesRequestsPage from '@/views/articles/ArticlesRequestsPage.vue';
import ArticlesRequestsFormPage from '@/views/articles/ArticlesRequestsFormPage.vue';
import ArticlesRequestsViewPage from '@/views/articles/ArticlesRequestsViewPage.vue';
import PublipostsPage from "@/views/publiposts/PublipostsPage.vue";
import PublipostFormPage from "@/views/publiposts/PublipostFormPage.vue";
import NotFoundPage from "@/views/NotFoundPage.vue";

const routes = [
  {
    path: '/login',
    name: 'login',
    component: AuthLogin,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/register',
    name: 'register',
    component: AuthRegister,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/login/recovery',
    name: 'recovery',
    component: AuthRecovery,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/login/recovery/change-password',
    name: 'recoveryChangePassword',
    component: AuthRecoveryChangePassword,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/invitation/:code',
    name: 'invitation',
    component: AuthInvitation,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles',
    name: 'articles',
    component: ArticlesPage,
    meta: {
      requiresAuth: true,
      profileType: 'redator'
    },
  },
  {
    path: '/articles/step',
    name: 'articleStepForm',
    component: ArticleStepPage,
    meta: {
      requiresAuth: true,
      profileType: 'redator'
    },
  },
  {
    path: '/articles/create',
    name: 'articleCreate',
    component: ArticlesFormPage,
    meta: {
      requiresAuth: true,
      profileType: 'redator'
    },
  },
  {
    path: '/articles/generate',
    name: 'articleGenerate',
    component: ArticlesGenerateFormPage,
    meta: {
      requiresAuth: true,
      profileType: 'redator'
    },
  },
  {
    path: '/articles/:id',
    name: 'articleEdit',
    component: ArticlesFormPage,
    meta: {
      requiresAuth: true,
      profileType: 'redator'
    },
  },
  {
    path: '/articles/share',
    name: 'articlesShare',
    component: ArticlesSharePage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles/share',
    name: 'articlesShareNovelas',
    component: ArticlesSharePage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles/share',
    name: 'articlesShareEsportes',
    component: ArticlesSharePage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles/share',
    name: 'articlesShareAFazenda',
    component: ArticlesSharePage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles/top-links',
    name: 'articlesTopLinks',
    component: ArticlesTopLinksPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles/links',
    name: 'articlesLinks',
    component: ArticlesLinksPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/articles/requests',
    name: 'articlesRequests',
    component: ArticlesRequestsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/articles/requests/create',
    name: 'articleRequestCreate',
    component: ArticlesRequestsFormPage,
    meta: {
      requiresAuth: true,
      profileType: 'publisher'
    },
  },
  {
    path: '/articles/requests/:id',
    name: 'articleRequestView',
    component: ArticlesRequestsViewPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/social-pages',
    name: 'socialPages',
    component: SocialPages,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/social-pages/create',
    name: 'socialPageCreate',
    component: SocialPagesFormPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/social-pages/:id',
    name: 'socialPageEdit',
    component: SocialPagesFormPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/supports',
    name: 'supports',
    component: SupportsPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/supports/create',
    name: 'supportCreate',
    component: SupportsFormPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/supports/:id',
    name: 'support',
    component: SupportsViewPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/pre-authorizations',
    name: 'preAuthorizations',
    component: PreAutorizationsPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/pre-authorizations/create',
    name: 'preAuthorizationCreate',
    component: PreAutorizationsFormPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/pre-authorizations/:id',
    name: 'preAuthorization',
    component: PreAutorizationsViewPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessagesPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/messages/:id',
    name: 'message',
    component: MessagesViewPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/faqs',
    name: 'faqs',
    component: FaqsPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/faqs/:id',
    name: 'faq',
    component: FaqsViewPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/reports/articles',
    name: 'reportArticles',
    component: ReportsArticlesPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/reports/articles/:id',
    name: 'reportArticle',
    component: ReportsArticlePage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/reports/pages',
    name: 'reportPages',
    component: ReportPages,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/reports/pages/:id',
    name: 'reportPage',
    component: ReportPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/payments',
    name: 'payments',
    component: PaymentsPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/payments/:id',
    name: 'payment',
    component: PaymentsViewPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/account',
    name: 'account',
    component: AccountPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/suggestions',
    name: 'suggestions',
    component: SuggestionsPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/suggestions/create',
    name: 'suggestionCreate',
    component: SuggestionsFormPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/suggestions/:id',
    name: 'suggestionEdit',
    component: SuggestionsFormPage,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/publiposts',
    name: 'publiposts',
    component: PublipostsPage,
    meta: {
      requiresAuth: true,
      profileType: 'publipost'
    },
  },
  {
    path: '/publiposts/:id',
    name: 'publipostEdit',
    component: PublipostFormPage,
    meta: {
      requiresAuth: true,
      profileType: 'publipost'
    },
  },
  {
    path: '/404',
    name: '404',
    component: NotFoundPage,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async function(to, from, next){
  const authStore = useAuthStore();
  const menuStore = useMenuStore();

  if(to.meta.requiresAuth){
    await authStore.checkLogin();
  }

  if(to.name == 'login' && authStore.isAuthenticated && authStore.forceLogout == false){
    next({ name: 'home' });
  }
  else if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login' });
  }
  else {
    if(authStore.isAuthenticated){
      authStore.checkNotifications();
    }

    if(to.meta.profileType && to.meta.profileType != authStore.user.profile_type){
      next({ name: 'home' });
    }

    /* Close left menu */
    menuStore.close();

    next();
  }
});

export default router;